// extracted by mini-css-extract-plugin
module.exports = {"crudButton":"Button_crudButton__dc8VN","green":"Button_green__28Sfh","red":"Button_red__3erBo","gold":"Button_gold__30f0o","grey":"Button_grey__1r0uI"};